import "./OpencontentpageStyles.scss";
import $ from "jquery";
import { globalContactCta } from "../FunctionsCore";
const opencontentpage = () => {
    $(() => {
        $(".contact_cta section.cta").on("click", (cl) => {
            cl.stopPropagation();
            globalContactCta.togglePanel();
        });
    });
};
export { opencontentpage };
